import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

async function fetchUserProfile() {
  const res = await fetch('/api/users/me', { credentials: 'include' })
  if (!res.ok) return null
  return res.json()
}

export const Route = createFileRoute('/platform')({
  beforeLoad: async ({ location }) => {
    try {
      const user = await fetchUserProfile()
      if (!user) throw new Error('not authenticated')

      if (user.role === 'platform_admin' || user.is_qc) {
        // QC tidak boleh akses halaman konfigurasi
        const adminOnlyPaths = ['/platform/pengguna', '/platform/pengaturan', '/platform/whatsapp-server']
        if (
          user.is_qc &&
          user.role !== 'platform_admin' &&
          adminOnlyPaths.some((p) => location.pathname.startsWith(p))
        ) {
          throw redirect({ to: '/platform' })
        }
        // Scoped admin tidak boleh akses halaman super-admin-only
        if (
          user.role === 'platform_admin' &&
          !user.is_super_admin &&
          adminOnlyPaths.some((p) => location.pathname.startsWith(p))
        ) {
          throw redirect({ to: '/platform' })
        }
        return { user }
      }

      // Staff roles → redirect ke /staff (akan di-redirect lagi ke /desa/:slug/dashboard nanti)
      const staffRoles = ['kepala_desa', 'sekretaris_desa', 'operator_desa']
      if (staffRoles.includes(user.role) && user.status === 'approved' && user.desa_id) {
        const slug = user.desa?.slug
        if (slug) throw redirect({ to: `/desa/${slug}/dashboard` as any })
        throw redirect({ to: '/parkir' })
      }

      // pending tanpa desa → pilih desa
      if (user.status === 'pending' && !user.desa_id) {
        throw redirect({ to: '/pilih-desa' })
      }

      throw redirect({ to: '/parkir' })
    } catch (e) {
      if ((e as any)?.to) throw e
      throw redirect({ to: '/login' })
    }
  },
  component: () => <Outlet />,
})
